import { render, staticRenderFns } from "./profit.vue?vue&type=template&id=f41ea528&scoped=true"
import script from "./profit.vue?vue&type=script&lang=js"
export * from "./profit.vue?vue&type=script&lang=js"
import style0 from "./profit.vue?vue&type=style&index=0&id=f41ea528&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f41ea528",
  null
  
)

export default component.exports